// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4a89b6eb","125":"bc337362","369":"09ee7e4f","465":"9d18956f","498":"12698ef4","703":"2f4d47b3","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};